module.exports = __webpack_public_path__ + "@/assets/img/book-open.eed40572.svg";